import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { Contact } from './contact.model';
import { ContactEditComponent } from '../contact-edit/contact-edit.component';
import { MessageType } from '../../core/message-dialog/message-type.enum';
import { ContactDeleteComponent } from '../contact-delete/contact-delete.component';
import { ContactListAssignComponent, ContactCustomField } from '../contact-list-assign/contact-list-assign.component';
import { ContactList } from '../contact-list.model';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../nav-menu/user-company.service';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})

export class ContactComponent implements OnInit, OnDestroy {

  @ViewChild('editModal', { static: false }) editModal: ContactEditComponent;
  @ViewChild('deleteDialog', { static: false }) deleteDialog: ContactDeleteComponent;
  @ViewChild('assignForm', { static: false }) assignForm: ContactListAssignComponent;

  private contactList: ContactList[] = [];
  private idContactList: number;
  private contacts: Contact[] = [];
  private dataTable: any;
  private dtTable: any;
  private usedInContactList: any[] = [];
  private checked: any[] = [];
  private selectedCompany: number;
  private subs = new SubSink()

  private navbarHeadline: any;

  constructor(private repository: HttpRepositoryService,
    private titleService: Title,
    private router: Router,
    private antiForgery: AntiForgeryTokenService,
    private companyService: UserCompanyService) { }

  ngOnInit() {
    this.subs.sink = this.companyService.currentSelectedCompanyCode.subscribe(resp => {
      this.titleService.setTitle("Link.Maketer - " + resp);
    });
    
    this.dataTable = $('#contactTable');
    this.navbarHeadline = $('#navbarHeadline');

    this.subs.sink = this.companyService.currentSelectedCompany.subscribe(cmpResp => {
      this.selectedCompany = cmpResp;

      this.subs.sink = this.repository.get<ContactList[]>('api/ContactList/GetContactLists?id=' + this.selectedCompany).pipe(map(x => x.data)).subscribe(resp => {
        this.contactList = resp;
      });

      this.createDataTable();
      this.loadData();
    });

  }

  private createDataTable() {
    var that = this;

    var dtOptions = {
      data: this.contacts,
      columns: [
        {
          name: 'id',
          visible: false

        },
        {
          name: 'email',
          width: '250px'
        },
        {
          name: 'phone',
          width: '150px'
        },
        {
          name: 'isEmailConfirmed',
          class: 'text-center',
          filterable: false,
          width: '100px',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          useFalseIcon: true
        },
        {
          name: 'isActive',
          width: '100px',
          class: 'text-center',
          renderBoolAsCheckbox: true,
          boolTrueValue: true,
          boolFalseValue: false,
          boolTrueDisplay: 'Active',
          boolFalseDisplay: 'Inactive',
          useFalseIcon: true
        },
        {
          name: 'insAt',
          width: '100px'
        },
        {
          name: 'contactLists',
          width: '300px'
        }
      ],
      orderBy: [[0, 'asc']],
      rowButtons: {
        header: 'Options',
        dropdown: {
          text: '<i class="fas fa-ellipsis-v"></i>',
          class: '',
        },
        buttons: [{
          text: '<i class="fas fa-edit pr-3"></i> Edit',
          class: 'editrow',
          dataAttributes: ['id'],
          action: function (id) {
            that.edit(id);
          }
        },
        {
          text: '<i class="fas fa-trash pr-3"></i> Remove',
          class: 'deleterow',
          dataAttributes: ['id'],
          action: function (id) {
            that.delete(id);
          }
        }]
      },
      buttons: [{
        text: '<i class="fas fa-plus"></i>',
        class: '',
        action: function () {
          that.create()
        }
      },
      {
        text: '<i class="fas fa-trash-alt"></i>',
        class: '',
        action: function () {
          that.deleteList()
        }
      },
      {
        text: '<i class="far fa-check-square"></i>',
        class: '',
        action: function () {
          that.assign()
        }
      },
      {
        text: '<i class="fas fa-file-upload"></i>',
        class: '',
        action: function () {
          if (that.selectedCompany == 0) {
            that.deleteDialog.show("You don't have any assigned companies, please contact your administrator to get one.", MessageType.OK, null, "Import contact.");
          } else {
            that.router.navigateByUrl('/importfile');
          }

        }
      }]
    };

    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }

    this.dtTable = this.dataTable.LinkTable(dtOptions);
  }

  private loadData() {
    this.navbarHeadline.html(" Contacts")

    if (this.idContactList == 0) {

      this.subs.sink = this.repository.get<Contact[]>('api/Contact/List?companyId=' + this.selectedCompany).pipe(map(x => x.data))
        .subscribe(resp => {
          this.contacts = resp;
          this.createDataTable();
        });
    }

    if (this.idContactList > 0) {
      this.subs.sink = this.repository.get<Contact[]>('api/Contact/FilterList/' + this.idContactList + '?companyId=' + this.selectedCompany).pipe(map(x => x.data))
        .subscribe(resp => {
          this.contacts = resp;
          this.createDataTable();
        });
    }
  }

  private onChange($event) {
    this.idContactList = $event.target.value;
  }

  private create() {
    if (this.selectedCompany == 0) {
      this.deleteDialog.show("You don't have any assigned companies, please contact your administrator to get one.", MessageType.OK, null, "Create contact.");
    } else {
      this.editModal.show(new Contact(), true, this.selectedCompany);
    }

  }

  private edit(id) {
    if (this.selectedCompany == 0) {
      this.deleteDialog.show("You don't have any assigned companies, please contact your administrator to get one.", MessageType.OK, null, "Update contact.");
    } else {
      var contact = this.contacts.find(x => x.id === id);

      if (contact) {
        this.subs.sink = this.repository.get<Contact>('api/Contact/Details/' + contact.id + '?companyId=' + this.selectedCompany).pipe(map(x => x.data))
          .subscribe(data => {
            this.editModal.show(data, false, this.selectedCompany);
          });
      }
    }
  }

  private delete(id) {
    if (this.selectedCompany == 0) {
      this.deleteDialog.show("You don't have any assigned companies, please contact your administrator to get one.", MessageType.OK, null, "Delete contact.");
    } else {
      var contact = this.contacts.find(x => x.id === id);
      this.usedInContactList = [];

      if (contact) {
        let conactInfo = contact.email ? contact.email : contact.phone;

        this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
          if (afResp.hasErrors) {
            Toast.Show(afResp.error, 'Delete contact', 'error');
          } else {
            this.subs.sink = this.repository.get<any>('api/Contact/Contains?companyId =' + this.selectedCompany + '?ids=' + id).subscribe(resp => {
              this.usedInContactList = resp.data;

              this.deleteDialog.show("Are you sure you want to delete " + conactInfo + "?", MessageType.YESNO, this.usedInContactList, "Delete conformation!", () => {
                this.subs.sink = this.repository.del("api/Contact/Remove/" + id + '?companyId=' + this.selectedCompany, afResp.data).subscribe(resp => {
                  if (resp.hasErrors) {
                    Toast.Show(resp.error, 'Delete contact', 'error');
                  } else {
                    Toast.Show('Contact successfully deleted.', 'Delete contact', 'success');
                    this.loadData();
                  }
                });
              });
            });
          }
        });
      }
    }
  }

  private deleteList() {
    if (this.selectedCompany == 0) {
      this.deleteDialog.show("You don't have any assigned companies, please contact your administrator to get one.", MessageType.OK, null, "Delete contact.");
    } else {
      let checked: number[] = this.dtTable._dataTable.rows('.selected').data().toArray().map(x => x.id);
      this.usedInContactList = [];

      if (checked.length == 0) {
        this.deleteDialog.show("You must select contact!", MessageType.OK, null, "Delete conformation!");
      } else {
        this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
          if (afResp.hasErrors) {
            Toast.Show(afResp.error, 'Delete contact', 'error');
          } else {
            this.subs.sink = this.repository.get<any>('api/Contact/Contains?companyId=' + this.selectedCompany + '&' + checked.map(x => 'ids = ' + x + ' & ').join("")).subscribe(resp => {
              this.usedInContactList = resp.data;

              this.deleteDialog.show("Are you sure you want do delete " + checked.length + " item(s)?", MessageType.YESNO, this.usedInContactList, "Delete conformation!", () => {
                this.subs.sink = this.repository.post<number[]>('api/Contact/ListRemove?companyId=' + this.selectedCompany, checked, afResp.data).subscribe(resp => {
                  if (resp.hasErrors) {
                    Toast.Show(resp.error, 'Delete contact(s)', 'error');
                  } else {
                    Toast.Show('Contact(s) successfully deleted.', 'Delete contact(s)', 'success');
                    this.loadData();
                  }
                });
              });
            });
          }
        });
      }
    }
  }

  private onSaved(data: Contact) {
    var contact: Contact = this.contacts.find(x => x.id === data.id);

    if (contact) {
      contact.email = data.email;
      contact.phone = data.phone;
    } else {
      data.isActive = true;
      this.contacts.push(data);
    }

    this.createDataTable();
  }

  private onAssigned(data: ContactCustomField[]) {
    this.loadData();
  }

  private onUnsubscribed(data: Contact) {
    this.loadData();
  }

  private assign() {
    if (this.selectedCompany == 0) {
      this.deleteDialog.show("You don't have any assigned companies, please contact your administrator to get one.", MessageType.OK, null, "Assign contact.");
    } else {
      this.checked = this.dtTable._dataTable.rows('.selected').data().toArray().map(x => ({ id: x.id, email: x.email, phone: x.phone, isActive: x.isActive }))

      if (this.checked.length == 0) {
        this.deleteDialog.show("You must select contact!", MessageType.OK, null, "Assign conformation!"); //only for displaying msg
      } else {
        this.assignForm.show(this.checked, this.selectedCompany);
      }
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();

    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }
  }
}
